<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { Models } from '@smartlinkdev/types';
  import { languages, activeLanguage } from '$lib/stores/languages';
  import { setLocale, t } from '$lib/translations';

  export let show;
  let currentLang: Models.Language;

  activeLanguage.subscribe((newActiveLang) => {
    currentLang = newActiveLang;
  });

  const setLocaleCookie = (locale: string): void => {
    const oneYear = 60 * 60 * 24 * 365;
    const val = `locale=${locale}; path=/; max-age=${oneYear}`;
    document.cookie = val;
  };

  const updateActiveLang = (lang: Models.Language): void => {
    activeLanguage.set(lang);
    setLocaleCookie(lang.abbreviation);
    setLocale(lang.abbreviation);
  };

  const dispatch = createEventDispatcher();
  const close = () => {
    dispatch('close');
  };
</script>

<div
  id="langSelector"
  class:hide={!show}
  class:show={show}
>
  <div
    id="close-btn"
    on:click={close}
    on:keydown={close}
  >
    <span class="material-symbols-outlined cursor-pointer">cancel</span>
  </div>
  <h2>{ $t('content.selectLang') }</h2>
  {#each $languages as lang (lang.abbreviation)}
    <div
      class="language"
      class:active={lang.abbreviation.toLowerCase() === currentLang.abbreviation.toLowerCase()}
      on:click={() => { updateActiveLang(lang) }}
      on:keydown={() => { updateActiveLang(lang) }}
    >
      {lang.name}
    </div>
  {/each}
</div>

<style lang="postcss">
    :global(#langSelector) {
        -webkit-box-shadow: 0px 0px 28px 3px rgba(0,0,0,0.5);
        -moz-box-shadow: 0px 0px 28px 3px rgba(0,0,0,0.5);
        box-shadow: 0px 0px 28px 3px rgba(0,0,0,0.5);
        @apply fixed z-[60] bg-white rounded-3xl p-4;
        transition: top 0.5s;
        right: 30vw;
        text-align: center;
    }
    :global(.leftMenu #langSelector) {
        right: unset;
        left: 30vw;
    }

    #langSelector #close-btn {
        @apply absolute top-2 right-2 cursor-pointer;
    }

    #langSelector h2 {
        @apply mt-4 text-lg font-semibold text-sm;
    }

    #langSelector .language {
        @apply cursor-pointer hover:bg-gray-100 text-sm p-2;
    }

    .active {
        @apply bg-gray-800 text-white font-bold rounded rounded-lg;
    }

    .hide {
        top: -50vh;
    }

    .show {
        top: 4vh;
    }
</style>
